// Common provider settings so most users only need to enter email + password.
export const MAIL_PROVIDERS = [
  {
    key: "gmail",
    label: "Gmail / Google Workspace",
    domains: ["gmail.com", "googlemail.com"],
    imap: { host: "imap.gmail.com", port: 993, secure: true },
    smtp: { host: "smtp.gmail.com", port: 465, secure: true },
    hint: "Gmail requires an app password (Google Account → Security → App passwords)."
  },
  {
    key: "outlook",
    label: "Outlook / Microsoft 365",
    domains: ["outlook.com", "hotmail.com", "live.com", "outlook.de", "hotmail.de"],
    imap: { host: "outlook.office365.com", port: 993, secure: true },
    smtp: { host: "smtp.office365.com", port: 587, secure: false },
    hint: "Your Microsoft 365 administrator may need to allow IMAP/SMTP access for this mailbox."
  },
  {
    key: "ionos",
    label: "IONOS (1&1)",
    domains: [],
    imap: { host: "imap.ionos.de", port: 993, secure: true },
    smtp: { host: "smtp.ionos.de", port: 465, secure: true }
  },
  {
    key: "strato",
    label: "Strato",
    domains: [],
    imap: { host: "imap.strato.de", port: 993, secure: true },
    smtp: { host: "smtp.strato.de", port: 465, secure: true }
  },
  {
    key: "gmx",
    label: "GMX",
    domains: ["gmx.de", "gmx.net", "gmx.at", "gmx.ch"],
    imap: { host: "imap.gmx.net", port: 993, secure: true },
    smtp: { host: "mail.gmx.net", port: 465, secure: true },
    hint: "Enable IMAP access in the GMX settings (E-Mail → POP3/IMAP Abruf) first."
  },
  {
    key: "webde",
    label: "WEB.DE",
    domains: ["web.de"],
    imap: { host: "imap.web.de", port: 993, secure: true },
    smtp: { host: "smtp.web.de", port: 587, secure: false },
    hint: "Enable IMAP access in the WEB.DE settings (POP3/IMAP Abruf) first."
  },
  {
    key: "tonline",
    label: "T-Online",
    domains: ["t-online.de"],
    imap: { host: "secureimap.t-online.de", port: 993, secure: true },
    smtp: { host: "securesmtp.t-online.de", port: 465, secure: true },
    hint: "T-Online requires a separate email password from the Telekom Kundencenter."
  },
  {
    key: "yahoo",
    label: "Yahoo",
    domains: ["yahoo.com", "yahoo.de"],
    imap: { host: "imap.mail.yahoo.com", port: 993, secure: true },
    smtp: { host: "smtp.mail.yahoo.com", port: 465, secure: true },
    hint: "Yahoo requires an app password."
  },
  {
    key: "custom",
    label: "Other (manual settings)",
    domains: [],
    imap: { host: "", port: 993, secure: true },
    smtp: { host: "", port: 465, secure: true }
  }
];

export const detectProvider = email => {
  const domain = (email || "").split("@")[1]?.toLowerCase();
  if (!domain) return null;
  return MAIL_PROVIDERS.find(provider => provider.domains.includes(domain)) || null;
};
